import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as insight360Actions from '../../../actions/insight360Actions';
import { getColorCodeForGivenCategory } from '../../../util/Insight360Utils';
import { ATTITUDE_ICON_LIST } from '../../../constants';

const getImageIcon = imageKey => {
  let selectedIcon;
  const imageComponent = _.find(ATTITUDE_ICON_LIST, { id: imageKey });
  if (imageComponent !== undefined) {
    selectedIcon = imageComponent.selectedIcon;
  }
  return selectedIcon;
};

const renderDeepDiveSlider = (value, personaIndex, categoryName,
  selectedTab, displayDeepDiveSlider) => {
  const deepDivePersonaObject = {
    personaIndex,
    category: categoryName,
    section: 'Attitudes',
    selectedTab,
  };
  displayDeepDiveSlider(value, deepDivePersonaObject);
};
const AttitudesSinglePersonaDetail = ({
  attitudeDetail,
  highestIndex,
  selectedIcon,
  categoryme,
  personaIndex,
  selectedTab,
  displayDeepDiveSlider,
  studyName,
}) => {
  let attitudeName = '';
  let index = 0;
  let reach = 0;
  let statement = '';
  let widthPercent = 0;
  let widthPercentValue = 0;
  if (attitudeDetail !== undefined) {
    index =
      attitudeDetail.data !== undefined
        ? attitudeDetail.data.value.index
        : 'N/A';
    reach =
      attitudeDetail.data !== undefined
        ? attitudeDetail.data.value.pct
        : 'N/A';
    statement =
      attitudeDetail.data !== undefined
        ? attitudeDetail.data.label
        : 'N/A';
    attitudeName = attitudeDetail.categoryName;
    widthPercentValue = _.round((index * 100) / highestIndex);
    widthPercent = isNaN(widthPercentValue)
      ? '100%'
      : `${widthPercentValue}%`;
  }
  return (
    <div>
      {attitudeDetail !== undefined &&
        highestIndex !== undefined && (<div className="attitude-detail-grid">
          <div className="attitude-comparision-float">
            <div className="attitude-float">
              <div className="attitude-image-border attitude-float">
                {getImageIcon(selectedIcon) ===
                  undefined && <div className="imageblock" />}
                {getImageIcon(selectedIcon) !==
                  undefined && (<img
                    className="i360-demo-comparision-img pointer-cursor"
                    src={getImageIcon(selectedIcon)}
                    alt={categoryme}
                    onClick={() => {
                      renderDeepDiveSlider(true, personaIndex,
                        attitudeName, selectedTab, displayDeepDiveSlider);
                    }}
                  />
                  )}
                <div className="attitude-comparision-icon-labels pointer-cursor"
                  onClick={() => {
                    renderDeepDiveSlider(true, personaIndex,
                    attitudeName, selectedTab, displayDeepDiveSlider);
                  }}
                >
                  {attitudeName}
                </div>
              </div>
            </div>

            <div
              className="attitude-comparision-metrics attitude-float pointer-cursor"
              onClick={() => {
                renderDeepDiveSlider(true, personaIndex,
                  attitudeName, selectedTab, displayDeepDiveSlider);
              }}
            >
              <div>INDEX:&nbsp;&nbsp;{index}</div>
              <div>REACH:&nbsp;&nbsp;{reach} </div>
            </div>

            <div className="attitude-comparision-statement-float">
              <div className="large-12 medium-12 small-12 columns">
                <div
                  className="attitude-status-bar pointer-cursor"
                  style={{
                    width: widthPercent,
                    backgroundColor: getColorCodeForGivenCategory(
                      attitudeName,
                      studyName,
                    ),
                  }}
                  onClick={() => {
                    renderDeepDiveSlider(true, personaIndex,
                      attitudeName, selectedTab, displayDeepDiveSlider);
                  }}
                />
                <div
                  className="attitude-comparision-data insight360-attitude-align pointer-cursor"
                  title={statement}
                  onClick={() => {
                    renderDeepDiveSlider(true, personaIndex,
                      attitudeName, selectedTab, displayDeepDiveSlider);
                  }}
                >
                  <span>{statement}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
    </div>
  );
};

AttitudesSinglePersonaDetail.propTypes = {
  attitudeDetail: PropTypes.shape({}),
  highestIndex: PropTypes.number,
  selectedIcon: PropTypes.string,
  categoryme: PropTypes.string,
  displayDeepDiveSlider: PropTypes.func,
  personaIndex: PropTypes.number,
  selectedTab: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  const displayDeepDiveSlider = (value, deepDivePersonaObject) => {
    dispatch(insight360Actions.showDeepDivePopup(value, deepDivePersonaObject));
  };
  return {
    displayDeepDiveSlider,
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
)(AttitudesSinglePersonaDetail);
